var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "dropdown" },
    [
      _c(
        _setup.Button,
        {
          staticClass: "btn-sm dropdown-toggle",
          attrs: { "data-bs-toggle": "dropdown" },
        },
        [_vm._v("\n        " + _vm._s(_setup.selectedSectionTitle) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dropdown-menu" },
        _vm._l(_setup.sectionsData, function (section) {
          return _c(
            "button",
            {
              key: section.tableName,
              staticClass: "dropdown-item",
              class: { active: section.tableName === _setup.sectionName },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _setup.setSectionName(section.tableName)
                },
              },
            },
            [_vm._v("\n            " + _vm._s(section.title) + "\n        ")]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }